/** Facade angle on the floor plan: one number — DB `rotation` (degrees). */

// ponytail: mirrors rotation→orientation for RacksLayer until orientation field is deleted from RackNode.
export function facadeFromApiRotation(rotation: number | null | undefined): {
  rotation: number
  orientation: number
} {
  const r = rotation || 0
  return { rotation: r, orientation: r }
}

/** Prefer persisted rotation; orientation is session mirror only. */
export function facadeDeg(node: { rotation?: number; orientation?: number }): number {
  return node.rotation ?? node.orientation ?? 0
}
